// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__RBY9-","empty":"ModalGraph_empty__3M3yq"};